// Colaboradores API service
import { api } from './api'

export interface Colaborador {
    id: string
    user_id: number
    empresa: string
    nif: string
    funcionario: string
    tipo_veiculo: string
    ano_veiculo: number
    matricula: string
    cidade: string
    created_at: string
    updated_at: string
}

export interface ColaboradorCountInfo {
    count: number
    max_colaboradores: number
    can_add_more: boolean
}

export interface CreateColaboradorData {
    empresa: string
    nif: string
    funcionario: string
    tipo_veiculo: string
    ano_veiculo: number
    matricula: string
    cidade: string
}

export interface UpdateColaboradorData {
    empresa?: string
    nif?: string
    funcionario?: string
    tipo_veiculo?: string
    ano_veiculo?: number
    matricula?: string
    cidade?: string
}

export interface ColaboradoresListResponse {
    colaboradores: Colaborador[]
    count_info: ColaboradorCountInfo
    timestamp: string
}

export interface ColaboradorResponse {
    colaborador: Colaborador
    timestamp: string
}

export interface ColaboradorCreateResponse {
    message: string
    colaborador: Colaborador
    count_info: ColaboradorCountInfo
    timestamp: string
}

export interface ColaboradorUpdateResponse {
    message: string
    colaborador: Colaborador
    timestamp: string
}

export interface ColaboradorDeleteResponse {
    message: string
    count_info: ColaboradorCountInfo
    timestamp: string
}

// Colaboradores API
export const colaboradoresApi = {
    /**
     * List all colaboradores for the authenticated user
     */
    async list(): Promise<ColaboradoresListResponse> {
        return api.get<ColaboradoresListResponse>('/api/colaboradores')
    },

    /**
     * Get a specific colaborador by ID
     */
    async get(id: string): Promise<ColaboradorResponse> {
        return api.get<ColaboradorResponse>(`/api/colaboradores/${id}`)
    },

    /**
     * Create a new colaborador
     */
    async create(data: CreateColaboradorData): Promise<ColaboradorCreateResponse> {
        return api.post<ColaboradorCreateResponse>('/api/colaboradores', data)
    },

    /**
     * Update an existing colaborador
     */
    async update(id: string, data: UpdateColaboradorData): Promise<ColaboradorUpdateResponse> {
        return api.put<ColaboradorUpdateResponse>(`/api/colaboradores/${id}`, data)
    },

    /**
     * Delete a colaborador
     */
    async delete(id: string): Promise<ColaboradorDeleteResponse> {
        return api.delete<ColaboradorDeleteResponse>(`/api/colaboradores/${id}`)
    }
}
